import { apiStart, apiComplete } from "./api";
import axiosBackend from "../../config/axios/axios-back-end";
import { message } from "antd";

export const applicationsGetAll = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const result = await axiosBackend.get("/api/applications");
      // console.log(result,'recieved dataset')
      dispatch(apiComplete());
      return result.data;
      // return orderBy(result.data, [(app) => app.app_name.toLowerCase()]);
    } catch (error) {
      console.log(error, "get all applciations");
      dispatch(apiComplete());
      return [];
    }
  };
};

export const applicationGetDefaultConfig = (id) => {
  return async (dispatch) => {
    try {
      dispatch(apiStart());
      const result = await axiosBackend.get(`/api/applications/${id}`);
      dispatch(apiComplete());
      return result.data;
    } catch (error) {
      console.log(error, "get application def config error");
      dispatch(apiComplete());
      return {};
    }
  };
};

export const applicationSetDefaultPermission = (id, config) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      await axiosBackend.put(`/api/applications/${id}/appconfig`, {
        app_config: config,
      });
      dispatch(apiComplete());
      message.success("Default configuration updated");
      return true;
    } catch (error) {
      dispatch(apiComplete());
      message.error("Configurations not updated");
      console.log(error, "set app config error");
      return false;
    }
  };
};
